const round10Decimals = (num) => {
  const factor = 10 ** 10;
  const scaled = Number((num * factor).toPrecision(15));
  return Math.round(scaled) / factor;
};

export default round10Decimals